import { Component, OnInit, Output, EventEmitter,OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { UserDetailsModule } from 'src/app/pages/user-details';
import { Observable, Subscription } from 'rxjs';
import { YourPension } from '../../../../model/ngrx/your-pension.model';
import * as YourPensionActions from '../../../../store/actions/your-pension.actions';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store/state/app.state';

import { GetCMSDataService, StartQuoteService, UtilService, SERVICE_END_POINT, QuoteDataCaptureService, AnalyticsService, CURRENT_ENVIROMENT, AuthService, LoaderService } from '../../../../shared';
import * as UserDataConfig from '../../config/user-data.config';
import * as BreadcrumbDataConfig from '../../../../common-components/config/user-data.config';

import * as loggedInDetailActions from '../../../../store/actions/loggedin-detail.action';
import * as RefNoActions from '../../../../store/actions/reference-number.actions';
import * as BeforeYouStartActions from '../../../../store/actions/before-start.actions';
import * as DependantDetailsActions from '../../../../store/actions/dependant-details.actions';
import * as PersDetailsActions from '../../../../store/actions/personal-details.actions';
import * as QuotePlaybackRiskWarningActions from '../../../../store/actions/playback-risk-warnings.actions';
import * as ProductChoiceActions from '../../../../store/actions/product-choice.actions';
import * as quoteResultActions from '../../../../store/actions/quote-result.actions';
import * as ReqQuoteCalculationActions from '../../../../store/actions/request-quote-calculation.actions';
import * as ResQuoteCalculationActions from '../../../../store/actions/response-quote-calculation.actions';
import * as ResQuoteDatacaptureActions from '../../../../store/actions/response-quote-datacapture.actions';
import * as LifeStyleActions from '../../../medical-underwriting/store/actions/lifestyle.action';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent implements OnInit, OnDestroy {
  userForm: UntypedFormGroup;
  default: string;
  contentData;
  dealPartner:string;
  private CMSData;
  private CMSDataArray = [];
  private screenName;
  public displayAlert = false;
  serverDetail;
  isloading: boolean = false;
  cameFromMicrosite = false;
  login_str1;
  login_str2;
  login_str3;
  isExpanded: boolean = true; //changed as per the story RA-1778 by Suvetha V

  public userInputDetail = UserDataConfig.ElementsConfig;
  @Output() valueChange = new EventEmitter();
  private subscripBeforeLogin: Subscription;
  constructor(private fb: UntypedFormBuilder, private cmsService: GetCMSDataService, 
              private router: Router,private startQuoteService: StartQuoteService,
              private activatedRoute: ActivatedRoute,private quoteDatacaptureService: QuoteDataCaptureService,
              private utilService: UtilService, private store: Store<AppState>,
              private analyticsService: AnalyticsService, private authService: AuthService, private loaderService: LoaderService) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.getYourOnlineQuote;
    this.serverDetail = BreadcrumbDataConfig.BreadcrumbConfig.authServer;

  }
  ngOnInit() {
    // this.router.navigate(['/home/after-login']);
    this.GetCMSDataServiceMapper();
    this.dealPartner = this.activatedRoute.snapshot.queryParamMap.get('dealPartner') ? this.activatedRoute.snapshot.queryParamMap.get('dealPartner') : null;
    this.userFormData();
    this.subscripBeforeLogin = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLoginFunction.subscribe(() => {
      this.saveAfterLogin();
    });
  }



  userFormData = () => {
    // this.default = '-- Please select --';
    this.userInputDetail.buttonConfig.label = 'Next';
    this.userForm = this.fb.group({
      // firstname: ['', Validators.required],
      // lastname: ['', Validators.required],
      // // emailAddress: ['', [emailValidatorCheck]],
      // email: ['', Validators.required],
      // gender: [this.default, { onlySelf: true }],
      next: ['']
    });
  }

  saveAfterLogin() {
    this.utilService.afterSaveSuccesfully()
  }
  ngOnDestroy(){
    if(this.subscripBeforeLogin){
      this.subscripBeforeLogin.unsubscribe();
    }

  }

  toggleCollapse(): void {
    this.isExpanded = !this.isExpanded;
  }

    /** Code block for CMS */
    GetCMSDataServiceMapper() {
  const URL = SERVICE_END_POINT.higherEnvironment.CMS_GetYourOnlineQuote;
  this.utilService.getCMSData(URL).subscribe(res => {
    this.CMSData = res;
    if (this.CMSData) {
      /** In the line below we are over-writing the contentData object values with CMSData object values */
      this.contentData.header = this.CMSData.string_RegisternowTitle;
      this.contentData.landingPageIcon = this.CMSData.String_Moneyfactsimage;
      this.contentData.string_Whatyouneed = this.CMSData.string_Whatyouneed;
      this.contentData.string_Tickone = this.CMSData.string_Tickone;
      this.contentData.string_Ticktwo = this.CMSData.string_Ticktwo;
      const login_string = this.CMSData.string_loginhere;
      this.login_str1 = login_string.substring(login_string.lastIndexOf('>') + 1,login_string.length);
      this.login_str2 = login_string.substring(login_string.lastIndexOf('\">') + 2,login_string.lastIndexOf('</a>'));
      this.login_str3 = login_string.substring(0,login_string.lastIndexOf('<a'));
    }
  });
}


/** End of code block for CMS */

public getScreenName(currentscreen): string {
  const breadcrumbDetails = BreadcrumbDataConfig.BreadcrumbConfig.data.values;
  return breadcrumbDetails.find(br => br.screenName === currentscreen).path;
}
getCurrentScreenURL = () => {
  this.screenName = this.utilService.getScreenNameFromURL(this.router.url);
  return this.screenName;
}
afterSaveSuccessfully = () => {
  if (CURRENT_ENVIROMENT.environment !== 'localEnvironment') {
    // tslint:disable-next-line: max-line-length
    let serverName = '';
    if (document.location.href.toString().toUpperCase().includes('LOCALHOST')) {
      serverName = 'localhost';
    } else {
      if (document.location.href.indexOf('lgnet') > -1) {
        // tslint:disable-next-line: max-line-length
        serverName = document.location.href.substring(document.location.href.indexOf('//') + 2, document.location.href.indexOf('lgnet') - 1);
      } else {
        // tslint:disable-next-line: max-line-length
        serverName = document.location.href.substring(document.location.href.indexOf('//') + 2, document.location.href.indexOf('landg') - 1);
      }
    }
    const configServername = this.serverDetail.find(s => s.serverName === serverName);
    // // tslint:disable-next-line: max-line-length
    // if (this.referenceNumber) {
    //   this.quoteDatacaptureService.GetRefnumberEncrypted(this.referenceNumber.quoteReferenceNumber).subscribe(ref => {
    //     // tslint:disable-next-line: max-line-length
    //     this.quoteDatacaptureService.loginRedirect(`${configServername.secAuthUrl}/SAuthGateWeb/login.html?domain=dcj&entryPoint=${configServername.entryPointUrl}%2Feap%2Frequest%2Fdcj%2FcustomerLogin?quoteRefNo=${ref.quoteReference}`);
    //   });
    // } else {
    //   this.quoteDatacaptureService.loginRedirect(`${configServername.secAuthUrl}/SAuthGateWeb/login.html?domain=dcj&entryPoint=${configServername.entryPointUrl}%2Feap%2Frequest%2Fdcj%2FcustomerLogin`);
    // }
    this.quoteDatacaptureService.loginRedirect(`${configServername.secAuthUrl}/SAuthGateWeb/login.html?domain=dcj&entryPoint=${configServername.entryPointUrl}%2Feap%2Frequest%2Fdcj%2FcustomerLogin`);
  } else {
    this.quoteDatacaptureService.postLoginCapture('', '', '').subscribe(res => {
      if (res.showWarning === 'Y') {
        this.displayAlert = true;
      } else {
        const redirectUrl = this.getScreenName(res.currentScreen);
        this.router.navigate([redirectUrl]);
        //this.router.navigate(['/home/guidance-and-advice']);
      }
    }, error => this.displayAlert = false);
  }
}

onLogin = () => {
  this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'Login', pageID: this.getCurrentScreenURL() });
  // this.afterSaveSuccessfully();
  if (this.authService.isLoggedIn()) {
    sessionStorage.setItem('logInClicked', 'Y');
  }
  this.loaderService.handleSpinnerFlag({ show: true, onlyBackgroundFlag: false, Message: '', opacity: .4 });
  this.router.navigate(['/home/after-login']);
}

onRegister = () => {  
  sessionStorage.setItem('logInClicked', 'N');
  this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'Register', pageID: this.getCurrentScreenURL() });
  this.quoteDatacaptureService.onSave();
  this.isloading = true;
  this.startQuoteService.getQuoteReferenceNumber('NA').subscribe(data => {
    this.isloading = false;
    data.quoteNumberFlag = 1;
    data.editMode = false;
    data.applicationRefNumber = null;
   // this.store.dispatch(new Logout());
    this.store.dispatch(new loggedInDetailActions.RemoveLoggedInDetail(0));
    this.store.dispatch(new LifeStyleActions.RemoveLifestyleResult(0));
    this.store.dispatch(new BeforeYouStartActions.RemoveBeforeStart(0));
    this.store.dispatch(new DependantDetailsActions.RemoveDependantDetails(0));
    this.store.dispatch(new PersDetailsActions.RemovePersonalDetails(0));
    this.store.dispatch(new QuotePlaybackRiskWarningActions.RemoveQuotePlaybackRiskWarning(0));
    this.store.dispatch(new ProductChoiceActions.RemoveProductChoice(0));
    this.store.dispatch(new quoteResultActions.RemoveQuoteResult(0));
    this.store.dispatch(new ReqQuoteCalculationActions.RemoveReqQuoteCalculation(0));
    this.quoteDatacaptureService.requestQuoteCalculation = null;
    this.store.dispatch(new ResQuoteCalculationActions.RemoveQuoteCalculation(0));
    this.quoteDatacaptureService.responseQuoteCalculation = null;
    this.store.dispatch(new ResQuoteDatacaptureActions.RemoveQuoteCapture(0));
    let yourPensionObj: YourPension = {
      aegon: { fundValue: null, transferType: "CDF", productCode: [] },
      external: { fundValue: null, transferType: "Ext", productCode: [] },
      internal: { fundValue: null, transferType: "Int.", productCode: [] },
      manualSource: null,
      reAssure: { fundValue: null, transferType: "CDF", productCode: [] }, 
      sunLife: { fundValue: null, transferType: "CDF", productCode: [] },
      phoenixLife: { fundValue: null, transferType: "CDF", productCode: [] },
      pensionBee: { fundValue: null, transferType: "CDF", productCode: [] },
      aon: { fundValue: null, transferType: "CDF", productCode: [] },
     /* ddp1: { fundValue: null, transferType: "CDF", productCode: [] },
      ddp2: { fundValue: null, transferType: "CDF", productCode: [] },
      ddp3: { fundValue: null, transferType: "CDF", productCode: [] },
      ddp4: { fundValue: null, transferType: "CDF", productCode: [] },*/
      guarantees: null,
      penalties: null,
      totalSum: null,
      fundProvider: this.dealPartner?this.dealPartner:null,
      riskAndStaticQuestion: null,
      cedingFund:  null,
      productCodes: null,
      benefitTypes: null,
      cameFromMicrosite: true,
      fundValidateInd: false,
    };
    if (this.dealPartner) {
      this.store.dispatch(new YourPensionActions.RemoveYourPension(0));
      this.store.dispatch(new YourPensionActions.AddYourPension({...yourPensionObj }));
    }
    if ( !this.cameFromMicrosite) {
      this.store.dispatch(new YourPensionActions.RemoveYourPension(0));
    }
    this.store.dispatch(new RefNoActions.RemoveReferenceNumber(0));
    this.store.dispatch(new RefNoActions.AddReferenceNumber(data));
    this.router.navigate(['/home/registration']);
  });
}

alertPrimaryBtnClick = () => {
  this.displayAlert = false;
  this.quoteDatacaptureService.postLoginCapture('Y', 'EAPCAANDGCDMISMATCH', '').subscribe(res => {
    if (res.showWarning === 'Y') {
      this.displayAlert = true;
    } else {
      const redirectUrl = this.getScreenName(res.currentScreen);
      this.router.navigate([redirectUrl]);
    }
  }, error => this.displayAlert = false);
}

alertSecondaryBtnClick = () => {
  this.displayAlert = false;
}

closeModal = () => {
  this.displayAlert = false;
}
}
